export default {
  state: {
    windowWidth: 0,
  },
  mutations: {
    SET_WINDOW_WIDTH(state, payload) {
      console.log('Inside SET_WINDOW_WIDTH - payload:', payload)
      state.windowWidth = payload
    },
  },
  getters: {
    GET_WINDOW_WIDTH(state) {
      return state.windowWidth
    },
  },
}
